import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';

import { AboutDialogComponent } from '../about/about-dialog.component';

@Component({
    selector: 'app-fuse-about-dynamic',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: false
})
export class FuseAboutComponentDynamicComponent implements OnInit {
    constructor(
        private vcr: ViewContainerRef,
        private cfr: ComponentFactoryResolver
    ) {}

    ngOnInit() {
        const myComp = this.cfr.resolveComponentFactory(AboutDialogComponent);
        this.vcr.clear();
        this.vcr.createComponent(myComp);
    }
}
